import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=35bca9b9&scoped=true&"
import script from "./add-user.vue?vue&type=script&lang=js&"
export * from "./add-user.vue?vue&type=script&lang=js&"
import style0 from "./add-user.vue?vue&type=style&index=0&id=35bca9b9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bca9b9",
  null
  
)

export default component.exports